import React from "react";
import PropTypes from "prop-types";
import PlainButton from "@/components/plain-button/PlainButton";
import { ThemeContext } from "@/components/ThemeProvider";
import "./FavoritesControl.less";

export default class FavoritesControl extends React.Component {
  static propTypes = {
    item: PropTypes.shape({
      is_favorite: PropTypes.bool.isRequired,
      favorite: PropTypes.func.isRequired,
      unfavorite: PropTypes.func.isRequired,
    }).isRequired,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    onChange: () => {},
  };

  static contextType = ThemeContext;

  constructor(props) {
    super(props);
    this.state = {
      isFavorite: props.item.is_favorite
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item.is_favorite !== this.props.item.is_favorite) {
      this.setState({ isFavorite: this.props.item.is_favorite });
    }
  }

  toggleItem = (event) => {
    const { item, onChange } = this.props;
    const { isFavorite } = this.state;
    const action = isFavorite ? item.unfavorite.bind(item) : item.favorite.bind(item);

    action().then(() => {
      this.setState({ isFavorite: !isFavorite }, () => {
        onChange();
      });
    }).catch(error => {
      console.error('Error toggling favorite:', error);
    });
  }

  render() {
    const { isFavorite } = this.state;
    const { isDarkMode } = this.context;
    const icon = isFavorite ? "fa fa-star" : "fa fa-star-o";
    const title = isFavorite ? "Remove from favorites" : "Add to favorites";

    return (
      <PlainButton
        title={title}
        aria-label={title}
        className={`favorites-control btn-favorite ${isDarkMode ? 'dark-mode' : ''}`}
        onClick={this.toggleItem}>
        <i className={icon} aria-hidden="true" />
      </PlainButton>
    );
  }
}